// src/data/roomsData.js
// Real data based on Hotel Palais Royal specifications

export const roomsData = [
    {
      slug: "economy-single",
      title: "Small Single Room",
      titleKey: "rooms.economySingle.title",
      images: [
        require("../assets/images/Rooms/single-standard/1.JPG"),
        require("../assets/images/Rooms/single-standard/2.JPG"),
        require("../assets/images/Rooms/single-standard/3.JPG"),
        require("../assets/images/Rooms/single-standard/4.JPG"),
      ],
      descriptionKey: "rooms.economySingle.description",
      description: `Cozy and well-equipped room perfect for solo travelers. Features include minibar, desk, walk-in closet, shower, free toiletries, flat-screen TV with satellite channels, air conditioning, and complimentary Wi-Fi.`,
  
      roomInfo: {
        sizeKey: "rooms.economySingle.size",
        size: "16 m²",
        bedsKey: "rooms.economySingle.beds",
        beds: "1 Twin Bed",
        occupancyKey: "rooms.economySingle.occupancy",
        occupancy: "1 Person",
        viewKey: "rooms.economySingle.view",
        view: "City View",
      },
    },
    {
      slug: "superior-single",
      title: "Superior Single Room",
      titleKey: "rooms.superiorSingle.title",
      images: [
        require("../assets/images/Rooms/single-sup/1.JPG"),
        require("../assets/images/Rooms/single-sup/2.JPG"),
        require("../assets/images/Rooms/single-sup/3.JPG"),
        require("../assets/images/Rooms/single-sup/4.JPG"),
      ],
      descriptionKey: "rooms.superiorSingle.description",
      description: `Spacious single room with enhanced comfort. Features include minibar, desk, walk-in closet, private bathroom with bathtub and slippers, flat-screen TV with satellite channels, air conditioning, and complimentary Wi-Fi.`,
  
      roomInfo: {
        sizeKey: "rooms.superiorSingle.size",
        size: "21 m²",
        bedsKey: "rooms.superiorSingle.beds",
        beds: "1 Twin Bed",
        occupancyKey: "rooms.superiorSingle.occupancy",
        occupancy: "1 Person",
        viewKey: "rooms.superiorSingle.view",
        view: "City View",
      },
    },
    {
      slug: "economy-double",
      title: "Standard Double Room",
      titleKey: "rooms.economyDouble.title",
      images: [
        require("../assets/images/Rooms/double-standard/1.JPG"),
        require("../assets/images/Rooms/double-standard/2.JPG"),
        require("../assets/images/Rooms/double-standard/3.JPG"),
        require("../assets/images/Rooms/double-standard/4.JPG"),
      ],
      descriptionKey: "rooms.economyDouble.description",
      description: `Comfortable double room ideal for couples or friends. Features include 2 twin beds, minibar, desk, walk-in closet, shower, free toiletries, flat-screen TV, air conditioning, and complimentary Wi-Fi. Children's cribs available on request.`,
  
      roomInfo: {
        sizeKey: "rooms.economyDouble.size",
        size: "16 m²",
        bedsKey: "rooms.economyDouble.beds",
        beds: "2 Twin Beds",
        occupancyKey: "rooms.economyDouble.occupancy",
        occupancy: "2 People",
        viewKey: "rooms.economyDouble.view",
        view: "City View",
      },
    },
    {
      slug: "superior-double",
      title: "Superior Double Room",
      titleKey: "rooms.superiorDouble.title",
      images: [
        require("../assets/images/Rooms/double-sup/1.JPG"),
        require("../assets/images/Rooms/double-sup/2.JPG"),
        require("../assets/images/Rooms/double-sup/3.JPG"),
        require("../assets/images/Rooms/double-sup/4.JPG"),
      ],
      descriptionKey: "rooms.superiorDouble.description",
      description: `Spacious and elegantly decorated double room with enhanced amenities. Features include 2 twin beds, minibar, desk, walk-in closet, private bathroom with bathtub and slippers, flat-screen TV, air conditioning, and complimentary Wi-Fi. Crib available on request.`,
  
      roomInfo: {
        sizeKey: "rooms.superiorDouble.size",
        size: "21 m²",
        bedsKey: "rooms.superiorDouble.beds",
        beds: "2 Twin Beds",
        occupancyKey: "rooms.superiorDouble.occupancy",
        occupancy: "2 People",
        viewKey: "rooms.superiorDouble.view",
        view: "City View",
      },
    },
    {
      slug: "triple",
      title: "Triple Room",
      titleKey: "rooms.triple.title",
      images: [
        require("../assets/images/Rooms/triple/1.JPG"),
        require("../assets/images/Rooms/triple/2.JPG"),
        require("../assets/images/Rooms/triple/3.JPG"),
        require("../assets/images/Rooms/triple/4.JPG"),
      ],
      descriptionKey: "rooms.triple.description",
      description: `Spacious family room accommodating up to 3 adults and 2 children. Features include 3 twin beds, minibar, desk, walk-in closet, private bathroom with bathtub, flat-screen TV, air conditioning, and complimentary Wi-Fi. Cribs available on request.`,
  
      roomInfo: {
        sizeKey: "rooms.triple.size",
        size: "26 m²",
        bedsKey: "rooms.triple.beds",
        beds: "3 Twin Beds",
        occupancyKey: "rooms.triple.occupancy",
        occupancy: "3 Adults + 2 Children",
        viewKey: "rooms.triple.view",
        view: "City View",
      },
    },
    {
      slug: "suite",
      title: "King Suite",
      titleKey: "rooms.suite.title",
      images: [
        require("../assets/images/Rooms/suite/1.JPG"),
        require("../assets/images/Rooms/suite/2.JPG"),
        require("../assets/images/Rooms/suite/3.JPG"),
        require("../assets/images/Rooms/suite/4.JPG"),
        require("../assets/images/Rooms/suite/5.JPG"),
      ],
      descriptionKey: "rooms.suite.description",
      description: `Our most luxurious accommodation featuring a separate living area and private balcony. Includes 1 king bed (extra-long), coffee machine, minibar, desk, walk-in closet, bathroom with both bathtub and shower, flat-screen TV, air conditioning, and complimentary Wi-Fi.`,
  
      roomInfo: {
        sizeKey: "rooms.suite.size",
        size: "58 m²",
        bedsKey: "rooms.suite.beds",
        beds: "1 King Bed + Living Area",
        occupancyKey: "rooms.suite.occupancy",
        occupancy: "2 People",
        viewKey: "rooms.suite.view",
        view: "Panoramic City View with Balcony",
      },
    },
  ];